import "./bulldogs.scss";

import React, { useEffect, useState } from "react";
import BulldogImage from "../../assets/img/bulldogs__image.jpg";
import Btn from "../popUp/PopUp";

import BulldogImage1 from "../../assets/img/bulldogsImages/bulldogsImages__1.jpg";
import BulldogImage2 from "../../assets/img/bulldogsImages/bulldogsImages__2.jpg";
import BulldogImage3 from "../../assets/img/bulldogsImages/bulldogsImages__3.jpg";
import BulldogImage4 from "../../assets/img/bulldogsImages/bulldogsImages__4.jpg";
import BulldogImage5 from "../../assets/img/bulldogsImages/bulldogsImages__5.jpg";
import BulldogImage6 from "../../assets/img/bulldogsImages/bulldogsImages__6.jpg";
import BulldogImage7 from "../../assets/img/bulldogsImages/bulldogsImages__7.jpg";
import BulldogImage8 from "../../assets/img/bulldogsImages/bulldogsImages__8.jpg";

function Bulldogs({ setRef }: { setRef: React.RefObject<HTMLElement> }) {
  return (
    <section className="bulldogs" ref={setRef}>
      <div className="bulldogs__container container">
        <h2 className="bulldogs__text bulldogs__title">Nos bouledogues français — Big Rob Velvet et ses chiots</h2>
        <h3 className="bulldogs__text bulldogs__subtitle title-wp--line">
          MIGNON OFFORTUNE ne se consacre plus uniquement aux Spitz ! Nous sommes heureux de vous présenter notre bouledogue française Big
          Rob Vilvet et ses adorables chiots. Beauté, santé et excellent caractère — tout cela dans notre nouvelle portée.
        </h3>

        <ul className="bulldogs__list">
          <Bulldog images={[BulldogImage6, BulldogImage7, BulldogImage8]}>
            <h3 className="bulldogs__text bulldogs__name">Big Rob Velvet</h3>
            <p className="bulldogs__text bulldogs__description">
              Notre fierté — une bouledogue française élégante et puissante, avec une robe éclatante et un tempérament équilibré.
              Descendante de champions, elle possède une excellente santé et une belle anatomie.
            </p>
            <p className="bulldogs__text bulldogs__description">
              <strong>Nom complet:</strong> Big Rob Velvet
              <br />
              <strong>Génétique:</strong> Porteur de lilas, bleu, fauve
              <br />
              <strong>Caractère:</strong> Très affectueuse, elle s’entend parfaitement avec les enfants et les autres chiens.
              <br />
            </p>
          </Bulldog>
          <Bulldog images={[BulldogImage1, BulldogImage2, BulldogImage3, BulldogImage4, BulldogImage5]}>
            <h3 className="bulldogs__text bulldogs__name">Chiots de Velvet</h3>
            <p className="bulldogs__text bulldogs__description">
              Nés le 30 avril 2025 — de magnifiques chiots bouledogue français au pelage rare :
            </p>
            <p className="bulldogs__text bulldogs__description">
              🍼 Couleur : ISABELLA VELVET, ISABELLA TAN, BLUE MERLE, ISABELLA MERLE,BLEU TAN
              <br />
              👶 La moitié des chiots sont des mâles et des femelles
              <br />
              🩺 Examinés par un vétérinaire, en bonne santé, se développent très bien
              <br />
            </p>
            <p className="bulldogs__text bulldogs__description">
              Chaque chiot grandit dans l’amour et les soins. Nous sélectionnons soigneusement les familles !
            </p>
          </Bulldog>
        </ul>

        <Btn clazz="bulldogs__button" />
      </div>
    </section>
  );
}

function Bulldog({ images, children }: { images: string[]; children: JSX.Element[] }) {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveImage((i) => (i + 2 > images.length ? 0 : i + 1));
    }, 4000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <li className="bulldogs__item">
      <div className="bulldogs__image-wp">
        {images.map((url, i) => (
          <img className={i !== activeImage ? "bulldogs__image" : "bulldogs__image bulldogs__image--active"} src={url} alt="#" key={i} />
        ))}
      </div>
      <div className="bulldogs__text">{children}</div>
    </li>
  );
}

export default Bulldogs;
